import appStore from '../../images/app-store.png';
import appStore2x from '../../images/app-store@2x.png';
import appStore4x from '../../images/app-store@4x.png';
import playMarket from '../../images/play-market.png';
import playMarket2x from '../../images/play-market@2x.png';
import playMarket4x from '../../images/play-market@4x.png';

const mapping = {
  'app-store': { '1x': appStore, '2x': appStore2x, '4x': appStore4x },
  'play-market': { '1x': playMarket, '2x': playMarket2x, '4x': playMarket4x }
};

export { mapping };